module.exports = __webpack_public_path__ + "img/文化活动.e0356c3d.png";